import Client from '@/client'

export default {
  get_map_data(id, payload) {
    return Client.post(`economics/${id}/get_map_data/`, payload)
  },
  get_aggregates(id, payload) {
    return Client.post(`economics/${id}/get_aggregates/`, payload)
  },
  get_wells(id, payload) {
    return Client.post(`economics/${id}/get_wells/`, payload)
  },
  get_ratios(id, payload) {
    return Client.post(`economics/${id}/get_ratios/`, payload)
  },
  get_first_year(id, payload) {
    return Client.post(`economics/${id}/get_first_year/`, payload)
  },
  get_report(id, payload) {
    return Client.post(`economics/${id}/get_report/`, payload, {
      responseType: 'blob'
    })
  },
  get_aggregate_summary(id, payload) {
    return Client.post(`economics/${id}/get_aggregate_summary/`, payload)
  },
}